import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";

const NotFoundPage = () => (
  <Layout>
    <div className="max-w-2xl mx-auto px-6 py-32 text-center">
      <div className="text-[11px] uppercase tracking-[0.2em] text-[#d4a54b] mb-4">404</div>
      <h1 className="text-[40px] md:text-[56px] font-semibold tracking-tight">Page not found</h1>
      <p className="text-white/55 mt-4 text-[14px]">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/" className="btn-primary mt-8 inline-flex">Back to dashboard</Link>
    </div>
  </Layout>
);

export default NotFoundPage;
